import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var MathematicsAdv = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.686 10.137c.16-.444.58-.74 1.052-.74h20.524c.617 0 1.118.5 1.118 1.118v2.909a1.119 1.119 0 1 1-2.237 0v-1.79H14.851l11.515 9.503a1.119 1.119 0 0 1 0 1.726l-11.515 9.503h16.292v-1.894a1.119 1.119 0 0 1 2.237 0v3.013c0 .618-.5 1.118-1.118 1.118H11.738a1.119 1.119 0 0 1-.712-1.981L23.896 22l-12.87-10.622c-.364-.3-.5-.797-.34-1.241Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.488 2.237c-2.35 0-4.25 1.9-4.25 4.251v31.024c0 2.35 1.9 4.25 4.25 4.25h31.024c2.35 0 4.25-1.9 4.25-4.25V6.488c0-2.35-1.9-4.25-4.25-4.25H6.488ZM0 6.488A6.485 6.485 0 0 1 6.488 0h31.024A6.485 6.485 0 0 1 44 6.488v31.024A6.485 6.485 0 0 1 37.512 44H6.488A6.485 6.485 0 0 1 0 37.512V6.488Z"
  }));
});
MathematicsAdv.displayName = 'MathematicsAdv';
MathematicsAdv.defaultProps = {
  'aria-label': 'MathematicsAdv'
};
export default MathematicsAdv;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/MathematicsAdv.js
// module id = 3040
// module chunks = 11